import { addMonths, endOfMonth, isAfter, isBefore, startOfMonth, subMonths, } from 'date-fns';
import { MONTH_STEP_NUMBER } from '../const';
export const getCanNavigateNextMonth = ({ currentDate, maxDate, }) => {
    if (!maxDate)
        return true;
    const nextMonthDate = addMonths(currentDate, MONTH_STEP_NUMBER);
    const startOfMonthDate = startOfMonth(nextMonthDate);
    const isCanNavigateNextMonth = !isAfter(startOfMonthDate, maxDate);
    return isCanNavigateNextMonth;
};
export const getCanNavigatePreviousMonth = ({ currentDate, minDate, }) => {
    if (!minDate)
        return true;
    const previousMonthDate = subMonths(currentDate, MONTH_STEP_NUMBER);
    const endOfMonthDate = endOfMonth(previousMonthDate);
    const isCanNavigatePreviousMonth = !isBefore(endOfMonthDate, minDate);
    return isCanNavigatePreviousMonth;
};
